import React, { useState } from 'react';
import { ArrowLeft, ArrowRight } from 'lucide-react';
import { Button } from '../ui/button';

const InhalationInjury = ({ onNext, onBack, onDataChange }) => {
  const [answers, setAnswers] = useState({});

  const keyQuestions = [
    { id: 'q1', text: 'Was the burn sustained in a closed space?' },
    { id: 'q2', text: "Is there soot in the patient's sputum?" },
    { id: 'q3', text: 'Is the patient hoarse?' },
    { id: 'q4', text: 'Are there burns to the face?' },
    { id: 'q5', text: 'Are there singed nasal hairs?' },
    { id: 'q6', text: 'Is there carbonaceous sputum?' },
    { id: 'q7', text: 'Are there burns inside the mouth?' },
    { id: 'q8', text: 'Is there a history of loss of consciousness?' },
    { id: 'q9', text: 'Was there an explosion?' },
    { id: 'q10', text: 'Is there a risk of inhalation injury?' }
  ];

  const handleAnswer = (questionId, answer) => {
    const newAnswers = { ...answers, [questionId]: answer };
    setAnswers(newAnswers);
    if (onDataChange) {
      onDataChange({ inhalation_injury: newAnswers });
    }
  };

  const handleNext = () => {
    if (onDataChange) {
      onDataChange({ inhalation_injury: answers });
    }
    onNext();
  };

  return (
    <div className="flex min-h-screen w-full items-center justify-center bg-black py-4">
      <div className="w-full max-w-sm mx-auto px-4">
        <div className="flex flex-col min-h-screen bg-zinc-900 rounded-3xl border-2 border-orange-500/30 shadow-2xl overflow-hidden">
          <div className="flex items-center justify-between p-4 border-b-2 border-orange-500/30">
            <Button onClick={onBack} variant="ghost" className="flex items-center gap-2 text-orange-500 text-lg font-bold">
              <ArrowLeft className="w-6 h-6" /> Back
            </Button>
            <h1 className="text-lg font-black text-orange-500">Inhalation Injury</h1>
            <div className="w-16" />
          </div>

          <div className="flex-grow overflow-y-auto bg-black p-4 space-y-5">
            <h2 className="text-xl font-black text-orange-400">Key Questions</h2>
            <div className="space-y-3">
              {keyQuestions.map((question) => (
                <div key={question.id} className="rounded-xl bg-zinc-900 p-4 border-2 border-orange-500/20">
                  <p className="text-base font-semibold text-orange-100 mb-3 leading-snug">{question.text}</p>
                  <div className="flex gap-2">
                    {['Yes', 'No', 'N/A'].map((option) => (
                      <button
                        key={option}
                        onClick={() => handleAnswer(question.id, option)}
                        className={`flex-1 py-2 px-3 rounded-lg text-base font-bold transition-all ${
                          answers[question.id] === option
                            ? 'bg-orange-500 text-white border-2 border-orange-400'
                            : 'bg-zinc-800 text-orange-200 border-2 border-orange-500/30 hover:bg-zinc-700'
                        }`}
                      >
                        {option}
                      </button>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="p-4 border-t-2 border-orange-500/30 bg-zinc-900">
            <Button onClick={handleNext} className="w-full h-14 bg-orange-500 text-white text-lg font-black rounded-xl hover:bg-orange-600 shadow-xl">
              Return to Primary Survey <ArrowRight className="w-6 h-6 ml-2" />
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InhalationInjury;